export default __webpack_public_path__ + "static/media/data-privacy-oval.feea3ffa.svg";